import timg1 from '../images/volunteer/1.jpg'
import timg2 from '../images/volunteer/2.jpg'
import timg3 from '../images/volunteer/3.jpg'
import timg4 from '../images/volunteer/4.jpg'
import timg5 from '../images/volunteer/5.jpg'
import timg6 from '../images/volunteer/6.jpg'
import timg7 from '../images/volunteer/7.jpg'




import Stime1 from '../images/volunteer-single/1.jpg'
import Stime2 from '../images/volunteer-single/2.jpg'
import Stime3 from '../images/volunteer-single/3.jpg'
import Stime4 from '../images/volunteer-single/4.jpg'
import Stime5 from '../images/volunteer-single/5.jpg'
import Stime6 from '../images/volunteer-single/6.jpg'
import Stime7 from '../images/volunteer-single/7.jpg'



const Teams = [
    // {
    //     id: '1',
    //     title: 'Leslie Alexander',
    //     subtitle: 'GRAPHIC DESIGNER',
    //     slug: 'Henry-Bannet',
    //     timg: timg1,
    //     Sime: Stime1,
    // },
    // {
    //     id: '2',
    //     title: 'Kristin Watson',
    //     subtitle: 'Human Recources',
    //     slug: 'Tanean-Akrasen',
    //     timg: timg2,
    //     Sime: Stime2,
    // },
    // {
    //     id: '3',
    //     title: 'Guy Hawkins',
    //     subtitle: 'Manager',
    //     slug: 'Lily-Margerat',
    //     timg: timg3,
    //     Sime: Stime3,
    // },
    // {
    //     id: '4',
    //     title: 'Albert Flores',
    //     subtitle: 'Department Head',
    //     slug: 'William-Watson',
    //     timg: timg4,
    //     Sime: Stime4,
    // },
    // {
    //     id: '5',
    //     title: 'Stevie Hanshaw',
    //     subtitle: 'Department Head',
    //     slug: 'William-Watson2',
    //     timg: timg5,
    //     Sime: Stime5,
    // },
    // {
    //     id: '6',
    //     title: 'Leslie Alexander',
    //     subtitle: 'GRAPHIC DESIGNER',
    //     slug: 'William-Watson3',
    //     timg: timg6,
    //     Sime: Stime6,
    // },
    // {
    //     id: '7',
    //     title: 'Rachelle Jansen',
    //     subtitle: 'Department Head',
    //     slug: 'William-Watson4',
    //     timg: timg7,
    //     Sime: Stime7,
    // },
    {
        title: "JAYARAMAKRISHNA ARIKATLA",
        subtitle: "President and Managing Trustee",
        timg: timg7,
        slug: "jayaramakrishna-arikatla",
        details: "S/o CHENCHAIAH, Aged about 45 years, Door No. 5-12 Regalagadda Palem Village, Kondapi Mandal, Prakasam Dt, Andhra Pradesh-523270. AADHAR: 863699866467"
    },
    {
        title: "RAM SURESH THOTAKURA",
        subtitle: "Vice President",
       timg: timg7,
        slug: "ram-suresh-thotakura",
        details: "S/O SAMBASIVA RAO, Aged about 45 years, Door No. 58-6-23(1), NEHRU NAGAR, SANTHAPETA, ONGOLE, Prakasam Dt, Andhra Pradesh-523001. AADHAR: 699077170985"
    },
    {
        title: "SRINIVASA RAO KOLLURI",
        subtitle: "Additional Vice President",
        timg: timg7,
        slug: "srinivasa-rao-kolluri",
        details: "S/O SUBRAHMANYAM, Aged about 46 years, Door No.57-1-29/11, Gosh Road, Beside Rambabu Hospital, Ongole, Prakasam Dt, Andhra Pradesh-523001. AADHAR: 449722064134"
    },
    {
        title: "PADMAJA GETTIBOYINA",
        subtitle: "Additional Vice President",
        timg: timg7,
        slug: "padmaja-gettiboyina",
        details: "W/O A MADHUSUDAN RAO, Aged about 45 years, Door No. B-504, Aparna Sarovar Grande, Nallagandla, Gopanpalli, K V Rangareddy, Telangana. AADHAR: 356315824351"
    },
    {
        title: "SUMA NOSINA",
        subtitle: "Additional Vice President",
       timg: timg7,
        slug: "suma-nosina",
        details: "W/O BOMBAY CHANDRA SEKHAR, Aged about 45 years, Door No.22-11-19/1, Wood Nagar, Chirala, Prakasam Dt, Andhra Pradesh-523155. AADHAR: 845112281121"
    },
    {
        title: "VENKATESWARLU POKURI",
        subtitle: "Additional Vice President",
        timg: timg7,
        slug: "venkateswarlu-pokuri",
        details: "S/O SUBBA RAO, Aged about 47 years, Chilakapadu (V), Machavaram (Post), S N Padu (Mdl), Prakasam Dt, Andhra Pradesh-523225. AADHAR: 830827198440"
    },
    {
        title: "HANUMANTHA RAO MUPPA",
        subtitle: "Chief Treasurer",
        timg: timg7,
        slug: "hanumantha-rao-muppa",
        details: "S/O ANJAIAH, Aged about 45 years, Door No. 4-46/6/5, Sai Nagar Colony, Chamachandrapuram-502032. AADHAR: 847141128149"
    },
    {
        title: "KAVITHA VENKATADRI",
        subtitle: "Treasurer",
        timg: timg7,
        slug: "kavitha-venkatadri",
        details: "W/O NALLURI NARASIMHAM, aged about 45 years, Kattubadipalem, Vennuru, Kondapi Mdl, Prakasam Dt, Andhra Pradesh-523270. AADHAR: 817223301482"
    },
    {
        title: "THELLA SUNIL CHIRANJEEVI RANJITHAM",
        subtitle: "Joint Secretary",
        timg: timg7,
        slug: "thella-sunil-chiranjeevi-ranjitham",
        details: "S/O BENJIMEN, Aged about 45 years, Door No. 53-1-41, ClughPet, 5th Line, Ongole, Prakasam Dt, Andhra Pradesh-523001. AADHAR: 402230801602"
    },
    {
        title: "RAMADEVI DHULIPALLA",
        subtitle: "General Secretary",
       timg: timg7,
        slug: "ramadevi-dhulipalla",
        details: "W/O SUDHAKAR, Aged about 46 years, Door No. 1-17C-37&38, Flat No. 502, Manikalyan Apartment, Rukmini Puri Colony, Srao Nagar, Kapra, Hyderabad, Telangana. AADHAR: 382779385841"
    },
    {
        title: "YUGANDHAR ARUNA",
        subtitle: "Trustee",
        timg: timg7,
        slug: "yugandhar-aruna",
        details: "D/O K BALA KRISHNA, Flat No. 301, Street No.5, Sravyas Nestle, Eshwaripuri Colony, Sainikpuri, Hyderabad, Telangana."
    },
    {
        title: "RAVINDRA BABU ADE",
        subtitle: "Trustee",
        timg: timg7,
        slug: "ravindra-babu-ade",
        details: "S/O RAVI KUMAR, Aged about 45 years, Door No. 2-2-40, Gaddalagunta, Opp MUP School, Ongole, Prakasam Dt, Andhra Pradesh-523001. AADHAR: 248381422990"
    },
    {
        title: "SRINIVASA RAO NALLURI",
        subtitle: "Trustee",
       timg: timg7,
        slug: "srinivasa-rao-nalluri",
        details: "S/O NARASIMHAM, Aged about 46 years, Kattubadipalem, Vennuru, Kondapi Mdl, Prakasam Dt, Andhra Pradesh-523270. AADHAR: 546325935517"
    },
    {
        title: "SOUMYA BOPPUDI",
        subtitle: "Trustee",
        timg: timg7,
        slug: "soumya-boppudi",
        details: "W/O BOPPUDI VENU, Door No. 34/25, Sri Ramachandra Mission, Opp Alankrutha Resort, Sri Partha Sarathi Nagar, Thumkunta, Shameer Pet Mandal, Ranga Reddy Dist, Telangana. AADHAR: 611575642525"
    },
    {
        title: "VENKATA TEJOSH PALADUGU",
        subtitle: "Trustee",
        timg: timg7,
        slug: "venkata-tejosh-paladugu",
        details: "S/O RAMA RAO, Aged about 46 years, flat No.402, Spring Leaf Apartment Nanjappa Layout, Bangalore South, Bannerghatta Road, Bangalore, Karnataka State. AADHAR: 779394727203"
    },
    {
        title: "SRINIVASA RAO GUNTURI",
        subtitle: "Trustee",
       timg: timg7,
        slug: "srinivasa-rao-gunturi",
        details: "S/O SUBRAHMANYAM, Aged about 45 years, Door No. 57-1-29/11, Gosh Road, Beside Rambabu Hospital, Ongole, Prakasam Dt, Andhra Pradesh-523001. AADHAR: 750865863071"
    },
    {
        title: "KIRAN KUMAR KOTHAPALLI",
        subtitle: "Trustee",
        timg: timg7,
        slug: "kiran-kumar-kothapalli",
        details: "Drivikng Lence No. 28654354, Aged about 45 years, Door No. 1532, MONTANA DR, Downing Town PA19335, USA."
    }
];

export default Teams;



